import { onBeforeUnmount, onMounted } from 'vue'

export const useWindowUnload = () => {
  const registerWarnUnloadEvent = (optionsOrText) => {
    const options = typeof optionsOrText === 'string'
      ? { text: optionsOrText }
      : (optionsOrText || {})

    const warnUnload = (e) => {
      if (typeof options.shouldWarn === 'function' && !options.shouldWarn()) {
        return undefined
      }

      e.preventDefault()
      return (e.returnValue = options.text || '確定離開頁面? 將不會儲存目前工作階段')
    }

    onBeforeUnmount(() => {
      window.removeEventListener('beforeunload', warnUnload, { capture: true })
    })

    onMounted(() => {
      window.addEventListener('beforeunload', warnUnload, { capture: true })
    })
  }

  return { registerWarnUnloadEvent }
}
